export default "__VITE_ASSET__Clb78w3T__"